var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.28,
    y: 28.98,
    className: "st0",
    width: 2.51,
    height: 17.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.8,47.27h-2.51c-0.27,0-0.5-0.22-0.5-0.5v-17.8c0-0.27,0.22-0.5,0.5-0.5h2.51c0.27,0,0.5,0.22,0.5,0.5 v17.8C44.29,47.05,44.07,47.27,43.8,47.27z M41.78,46.28h1.52V29.47h-1.52V46.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.77,
    y: 46.78,
    className: "st1",
    width: 38.03,
    height: 2.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.8,50H5.77c-0.27,0-0.5-0.22-0.5-0.5v-2.73c0-0.27,0.22-0.5,0.5-0.5H43.8c0.27,0,0.5,0.22,0.5,0.5v2.73 C44.29,49.78,44.07,50,43.8,50z M6.27,49.01H43.3v-1.74H6.27V49.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.86,15.7v14.26c0,1.27-1.05,2.32-2.32,2.32c-1.29,0-2.33-1.05-2.33-2.32V15.7c0-0.34,0.28-0.6,0.6-0.6 h3.45C44.6,15.1,44.86,15.36,44.86,15.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "44.89,6.12 32.3,40.84 9.03,40.84 21.62,6.12  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.3,41.34H9.03c-0.16,0-0.31-0.08-0.41-0.21c-0.09-0.13-0.12-0.3-0.06-0.45L21.15,5.95 c0.07-0.2,0.26-0.33,0.47-0.33h23.28c0.16,0,0.31,0.08,0.41,0.21c0.09,0.13,0.12,0.3,0.06,0.45L32.77,41.01 C32.7,41.21,32.51,41.34,32.3,41.34z M9.73,40.35h22.22L44.19,6.62H21.97L9.73,40.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.7,41.34H14.63c-0.16,0-0.31-0.08-0.41-0.21c-0.09-0.13-0.12-0.3-0.06-0.45L26.76,5.95 c0.07-0.2,0.26-0.33,0.47-0.33h12.07c0.16,0,0.31,0.08,0.41,0.21c0.09,0.13,0.12,0.3,0.06,0.45L27.17,41.01 C27.1,41.21,26.91,41.34,26.7,41.34z M15.34,40.35h11.02L38.59,6.62H27.57L15.34,40.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.67,41.34c-0.06,0-0.11-0.01-0.17-0.03c-0.26-0.09-0.39-0.38-0.3-0.63L32.79,5.95 c0.09-0.26,0.38-0.39,0.63-0.3c0.26,0.09,0.39,0.38,0.3,0.63L21.13,41.01C21.06,41.21,20.87,41.34,20.67,41.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.22,33.3H11.95c-0.16,0-0.31-0.08-0.41-0.21c-0.09-0.13-0.12-0.3-0.06-0.45L18.24,14 c0.07-0.2,0.26-0.33,0.47-0.33h23.27c0.16,0,0.31,0.08,0.41,0.21c0.09,0.13,0.12,0.3,0.06,0.45l-6.76,18.64 C35.61,33.17,35.43,33.3,35.22,33.3z M12.65,32.31h22.22l6.4-17.65H19.05L12.65,32.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.6,23.98H15.33c-0.27,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5H38.6c0.27,0,0.5,0.22,0.5,0.5 S38.87,23.98,38.6,23.98z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "46.66,8.47 34.07,43.18 10.8,43.18 9.02,40.84 32.31,40.84 44.9,6.12  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.07,43.67H10.8c-0.15,0-0.3-0.07-0.39-0.19l-1.78-2.33C8.52,41,8.5,40.79,8.58,40.63 c0.08-0.17,0.26-0.28,0.44-0.28h22.94l12.47-34.4c0.06-0.17,0.21-0.29,0.39-0.32c0.18-0.03,0.36,0.05,0.47,0.19l1.77,2.34 c0.1,0.13,0.13,0.31,0.07,0.47L34.54,43.34C34.47,43.54,34.28,43.67,34.07,43.67z M11.05,42.68h22.68L46.11,8.55l-1.05-1.4 L32.77,41.01c-0.07,0.2-0.26,0.33-0.47,0.33H10.03L11.05,42.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.81,6.73c0,2.34-1.9,4.24-4.24,4.24c-2.35,0-4.24-1.9-4.24-4.24c0-2.35,1.9-4.24,4.24-4.24 C11.91,2.48,13.81,4.38,13.81,6.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.16,
    className: "st1",
    width: 0.8,
    height: 1.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.16,
    y: 11.77,
    className: "st1",
    width: 0.8,
    height: 1.68
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.22,
    y: 0.79,
    transform: "matrix(0.866 -0.5 0.5 0.866 0.0726 3.5297)",
    className: "st1",
    width: 0.8,
    height: 1.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 10.98,
    transform: "matrix(0.866 -0.5 0.5 0.866 -4.2351 7.8375)",
    className: "st1",
    width: 0.8,
    height: 1.68
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.07,
    y: 2.94,
    transform: "matrix(0.5 -0.866 0.866 0.5 -1.0418 5.7619)",
    className: "st1",
    width: 0.8,
    height: 1.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.26,
    y: 8.83,
    transform: "matrix(0.5 -0.866 0.866 0.5 -1.0418 17.5309)",
    className: "st1",
    width: 0.8,
    height: 1.68
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.84,
    y: 6.32,
    className: "st1",
    width: 1.68,
    height: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.61,
    y: 6.32,
    className: "st1",
    width: 1.68,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.63,
    y: 9.27,
    transform: "matrix(0.866 -0.5 0.5 0.866 -4.2351 3.5297)",
    className: "st1",
    width: 1.68,
    height: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.82,
    y: 3.38,
    transform: "matrix(0.866 -0.5 0.5 0.866 0.0726 7.8375)",
    className: "st1",
    width: 1.68,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.78,
    y: 11.42,
    transform: "matrix(0.5 -0.866 0.866 0.5 -6.9264 11.6464)",
    className: "st1",
    width: 1.68,
    height: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.67,
    y: 1.23,
    transform: "matrix(0.5 -0.866 0.866 0.5 4.8427 11.6464)",
    className: "st1",
    width: 1.68,
    height: 0.8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPower);
export default __webpack_public_path__ + "static/media/solar-power.69ae19f221a2cba72e264030736899a8.svg";
export { ForwardRef as ReactComponent };